<template>
  <div class="whole">
    <TopTabbar :hastitle="true" title="历史记录"/>
    <div class="body">
      <div class="clearHistory" @click="clear()">清除历史</div>
      <div v-for="(item,index) in goodsList"
            :key="index">
        <div class="historyTime">{{item.time}}</div>
        <div class="historyList">
            <div  v-for="(items,indexs) in item.data"
            :key="indexs"  @click="jump(items.goodsId)" class="item">
            <div class="img">
              <img :src="items.goodsImg | thumbnail(720,720)" alt>
            </div>
            <div class="message">
              <div class="des" style="font-size:16px">{{items.goodsName}}</div>
              <div class="price" style="font-size:14px">￥{{items.goodsPrice}}</div>
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopTabbar from "@/components/TopTabbar.vue";
import Tabbar from "@/components/Tabbar.vue";
import { getListById } from "../../api/http.js";
import axios from "axios";
export default {
  components:{
    TopTabbar
  },
  data() {
    return {
      goodsList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let his = JSON.parse(localStorage.getItem("history"));
      let arr = new Array();
      for (let j in his) {
        let compareArr = arr.some(function(arr) {
          return arr == his[j].goods_id;
        });
        if (!compareArr) {
          arr.push(his[j].goods_id);
        }
      }
      let ajaxArr = "";
      for (let i in arr) {
        ajaxArr += arr[i] + ",";
      }
      ajaxArr = ajaxArr.substring(0, ajaxArr.length - 1);
      getListById(ajaxArr).then(res => {
        if (res.code == "1") {
          let resArr = res.data.data;
          this.goodsList = this.buildArr(resArr, his);
        }
      });
    },
    buildArr(resArr, his) {
      let result = new Array();
      for (let i in his) {
        let data = { goodsId: "", goodsImg: "", goodsPrice: "" ,goodsName:""};
        for (let j in resArr) {
          if (resArr[j].goods_id == his[i].goods_id) {
            data.goodsId = resArr[j].goods_id;
            data.goodsImg = resArr[j].image[0].file_path;
            data.goodsPrice = resArr[j].sku[0].goods_price;
            data.goodsName = resArr[j].goods_name;
            // data.goodsMinPrice = resArr[j].goods_min_price;
          }
        }
        if (
          result.length == 0 ||
          result[result.length - 1].time != his[i].time
        ) {
          result.push({
            time: his[i].time,
            data: [data]
          });
        } else {
          result[result.length - 1].data.push(data);
        }
      }
      return result;
    },
    jump(ids) {
      this.$router.push({
        path: "/details",
        query: {
          //路由传参时push和query搭配使用 ，作用是传递参数
          id: ids
        }
      });
    },
    clear(){
      localStorage.removeItem("history");
      this.$router.go(0)
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.whole {
  min-height: 100vh;
  background: #efefef;
  overflow: hidden;
  .title {
    width: 100%;
    position: fixed;
    height: 44px;
    background: #fff;
    text-align: center;
    z-index: 2;
    .back {
      position: absolute;
      top: 0px;
      left: 10px;
      width: 44px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 20px;
    }
    .titleName {
      font-size: 14px;
      margin: auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      z-index: -1;
    }
    .search {
      position: absolute;
      top: 0px;
      right: 10px;
      width: 44px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 20px;
    }
  }
  .body {
    margin: 10px 7px;
    margin-top: 44px;
    position: relative;
    .clearHistory {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 12px;
      padding: 0px 10px;
      color: #242424;
    }
    .historyTime {
      padding: 10px;
      font-size: 12px;
      color: #242424;
    }
    .historyList {
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 194px;
        // height: 232px;
        border-radius: 4px;
        background: #ffffff;
        margin-right: 8px;
        margin-bottom: 8px;
        overflow: hidden;
        border-radius: 4px;
        .img {
         height: 194px;
          // height: 328px;
          background: #f9f9f9;
          img {
            max-height: 100%;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .message {
          padding: 9px 10px;
          color: #3e210e;
          // font-style: PingFangSC-Semibold;
          // width:405px;
          background: rgba(255, 255, 255, 1);
          .des{
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>